enum VacancyPublicationType {
    Standard = 'STANDARD',
    StandardPlus = 'STANDARD_PLUS',
    Premium = 'PREMIUM',
    Free = 'FREE',
    StandardAnonymous = 'STANDARD_ANONYMOUS',
    StandardPlusAnonymous = 'STANDARD_PLUS_ANONYMOUS',
    PremiumAnonymous = 'PREMIUM_ANONYMOUS',
    StandardAdvertising = 'STANDARD_ADVERTISING',
    PremiumAdvertising = 'PREMIUM_ADVERTISING',
    ZPAnonymous = 'ZP_ANONYMOUS',
    ZPDemo = 'ZP_DEMO',
    ZPPromo = 'ZP_PROMO',
    ZPSprint = 'ZP_SPRINT',
    ZPBusiness = 'ZP_BUSINESS',
    PFP = 'PFP',
}

export default VacancyPublicationType;
